import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/bonus/select.png'
import _imports_1 from '@/assets/themeThree/down.png'
import _imports_2 from '@/assets/bonus/weikaishi_tu.png'
import _imports_3 from '@/assets/bonus/smactv2_btn_expire.png'
import _imports_4 from '@/assets/bonus/smactv2_btn_notstart.png'


const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = { class: "bonus_container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "day_row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "day_card" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "select_icon"
}
const _hoisted_9 = { class: "arrowIcon" }
const _hoisted_10 = {
  key: 0,
  style: {"width":"15px"},
  src: _imports_1,
  alt: ""
}
const _hoisted_11 = { style: {"padding":"15px"} }
const _hoisted_12 = {
  key: 0,
  class: "details_card"
}
const _hoisted_13 = { class: "middleTop" }
const _hoisted_14 = { class: "date_details" }
const _hoisted_15 = {
  key: 0,
  class: "tabel_container"
}
const _hoisted_16 = { style: {"font-size":"14px"} }
const _hoisted_17 = {
  key: 1,
  class: "bottom_text"
}
const _hoisted_18 = { class: "buttonFooter" }

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { ref } from 'vue';
import { BonusData, calculateValue, MYSTERIO_IMG_THREE } from '@/view/bonus/supportScript';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusView',
  props: {
    dataSet: {}
  },
  emits: ['pickMisteryGift', 'selectTab'],
  setup(__props: any, { emit: __emit }) {

const mysterioImages = ref(MYSTERIO_IMG_THREE)
const router = useRouter()
const props = __props

const emits = __emit

const pickMisteryGift = (activeStatus: number) => {
    emits('pickMisteryGift', activeStatus)
}

const selectTab = (item: any) => {
    emits('selectTab', item)
}



return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(CustomHeader, {
      text: _ctx.$t('bonus.mysterybonus'),
      bgColor: "#222428"
    }, null, 8, ["text"]),
    _cache[7] || (_cache[7] = _createTextVNode(": ")),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.dataSet.bannerIcon,
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.dayList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            onClick: ($event: any) => (selectTab(item))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(item.reward_day == _ctx.dataSet.selectedTab.reward_day ? 'select_content' : 'content')
              }, [
                _createElementVNode("img", {
                  src: mysterioImages.value[index].img,
                  alt: "",
                  width: "50%"
                }, null, 8, _hoisted_7),
                _createElementVNode("div", {
                  class: "date_text",
                  style: _normalizeStyle({ color: item.reward_day == _ctx.dataSet.selectedTab.reward_day ? '#ffff' : '' })
                }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.travel')) + " ", 1),
                  _createElementVNode("span", null, _toDisplayString(item.reward_day), 1)
                ], 4),
                (item.reward_data?.rewardCoin)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: ""
                      }, null, -1)
                    ])))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", _hoisted_9, [
                (item.reward_day == _ctx.dataSet.selectedTab.reward_day)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.dataSet.selectedTab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_van_row, { class: "details_content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_van_col, { span: "2" }),
                  _createVNode(_component_van_col, {
                    span: "12",
                    class: "label_text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('bonus.registrationTime')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "10",
                    class: "value_text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.mysteryDataConfig?.config?.user_join_date)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, { span: "2" }),
                  _createVNode(_component_van_col, {
                    span: "13",
                    class: "label_text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('bonus.totalDeposit')) + " " + _toDisplayString(_ctx.dataSet.selectedTab?.reward_day) + _toDisplayString(_ctx.$t('common.days')) + ":", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_col, {
                    span: "9",
                    class: "value_text"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("R$" + _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rechargeCoin
                                || 0)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_van_col, { span: "24" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_row, { class: "middleCard" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_van_col, {
                          span: "24",
                          class: "text_1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('bonus.claimTime')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_van_col, { span: "24" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(formatUnixTimestamp)(_ctx.dataSet.selectedTab?.reward_data?.rewardTime)), 1)
                          ]),
                          _: 1
                        }),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0)
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 0,
                              span: "24",
                              class: "misterio_text"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysterybonus')), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 || _ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 1,
                              span: "24",
                              class: "amount"
                            }, {
                              default: _withCtx(() => [
                                _cache[2] || (_cache[2] = _createTextVNode("R$ ")),
                                _createElementVNode("span", {
                                  style: _normalizeStyle({ color: _ctx.dataSet.selectedTab?.reward_data?.rewardCoin > 0 ? '#993900' : '' })
                                }, _toDisplayString(_unref(formatCurrency)(_ctx.dataSet.selectedTab?.reward_data?.rewardCoin || 0)), 5)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2 || (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin))
                          ? (_openBlock(), _createBlock(_component_van_col, {
                              key: 2,
                              span: "24",
                              class: "misterio"
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createElementVNode("img", {
                                  src: _imports_2,
                                  alt: ""
                                }, null, -1)
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.dataSet.selectedTab)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_van_row, { class: "tabel_hed" }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.depostiScope')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "2",
                class: "head_alignemnet"
              }),
              _createVNode(_component_van_col, {
                span: "11",
                class: "head_alignemnet"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('bonus.mysteryPrize')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.selectedTab?.reward_data?.reward_day_data, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_row, {
              class: "tabel_row",
              key: index,
              style: _normalizeStyle({
                    backgroundColor: index % 2 === 0 ? 'transparent' : 'rgba(0,0,0,.1)',
                    borderRadius: index === _ctx.dataSet.selectedTab?.reward_data?.reward_day_data.length - 1 ? '0px 0px 10px 10px' : ''
                })
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet"
                }, {
                  default: _withCtx(() => [
                    _cache[4] || (_cache[4] = _createTextVNode("R$ ")),
                    _createElementVNode("span", null, _toDisplayString(item.recharge_min < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_min))) + " ~ " + _toDisplayString(item.recharge_max < 0 ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.recharge_max))), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_van_col, {
                  span: "12",
                  class: "head_alignemnet currencyText"
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createTextVNode("R$ ")),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(item.show_reward_min < 0 ? '\u221E' :
                        _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_min))) + " ~ " + _toDisplayString(item.show_reward_max < 0
                                ? '\u221E' : _unref(formatCurrency)(_unref(calculateValue)(item.show_reward_max))), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["style"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.dataSet.activityInfo.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_van_row, { style: {"padding-bottom":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "24",
                class: "title"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t('common.eventRule')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataSet.activityInfo, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "line_text",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_van_row, null, {
        default: _withCtx(() => [
          (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 0,
                span: "24",
                class: "start_img"
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: ""
                  }, null, -1)
                ])),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 0 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 1,
                span: "24",
                class: "statusBar",
                style: {"color":"#66d329"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && !_ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 2,
                span: "24",
                class: "start_img2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "",
                    class: _normalizeClass({ 'pop-animate': _ctx.dataSet.isPopping }),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (pickMisteryGift(_ctx.dataSet.selectedTab?.reward_data?.activeStatus)))
                  }, null, 2)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 1 && _ctx.dataSet.selectedTab?.reward_data?.rewardCoin)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 3,
                span: "24",
                class: "statusBar",
                style: {"color":"#66d329"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('activityStatus.completed')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.dataSet.selectedTab?.reward_data?.activeStatus === 2)
            ? (_openBlock(), _createBlock(_component_van_col, {
                key: 4,
                span: "24",
                class: "statusBar",
                style: {"color":"#f8d8a7"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('rewards.notActivated')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})